import type { ReactNode } from "react";
import { I18nextProvider } from "react-i18next";

import { AviaryProvider } from "@aviary/utils";
import { ApolloProvider } from "@login/components/Providers/ApolloProvider/ApolloProvider";
import { RailsFlashProvider } from "@login/components/Providers/RailsFlashProvider/RailsFlashProvider";
import { GlobalContext } from "@login/context/GlobalContext";
import type { GlobalConfig } from "@login/data/globals/DefaultGlobals";
import type { FlashMessage } from "@login/data/types/FlashMessage.d";
import { i18n } from "@login/locales/i18n";
import { FlippersProvider } from "@shared/context/FlippersContext";
import { ScrollRestoration, BrowserRouter } from "@shared/react-router-dom/react-router-dom";
import type { Flipper } from "@shared/types/flipper";

interface Props {
  children: ReactNode;
  global: GlobalConfig;
  flashMessages: FlashMessage[];
  flippers: Flipper[];
}

const Providers = ({ children, global, flashMessages, flippers }: Props) => {
  return (
    <FlippersProvider flippers={flippers}>
      <I18nextProvider i18n={i18n}>
        <ApolloProvider>
          <BrowserRouter basename="/">
            <AviaryProvider>
              <GlobalContext value={global}>
                <RailsFlashProvider flashMessages={flashMessages}>
                  {children}
                  <ScrollRestoration />
                </RailsFlashProvider>
              </GlobalContext>
            </AviaryProvider>
          </BrowserRouter>
        </ApolloProvider>
      </I18nextProvider>
    </FlippersProvider>
  );
};
export { Providers };
